import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfirmationService, MessageService, MenuItem } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../services/user.service';
import { CustomValidators } from 'ng2-validation';
import { CommonService } from '../../../services/common.service';
import { environment } from 'src/environments/environment';
import { maxYearFunction } from '../../../_helpers/utility';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

@Component({
    selector: 'app-user-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss'],
    providers: [ConfirmationService, MessageService]
})

export class UserEditComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    // id;
    // userForm: FormGroup;
    // submitted = false;
    // uploadedFiles: any[] = [];
    // file: File;
    // reader: FileReader;
    // public profilepic;
    // errorMessage = '';
    // public item: any[] = [];
    // countrylist: any = [];
    // statelist: any = [];
    // citylist: any = [];
    // genders: any = [];
    // public imageProfile;
    // showProfile = false;
    // statuses: any = [];
    // userstatus: any;
    // usergender: any;
    // selectedStatus: any;
    // countryname;
    // countrycode;
    // statename;
    // statecode;
    // cityname;
    // citycode;
    // dob: Date;
    // dobdt: Date;
    // weddingDt: Date;
    // minYear = environment.minYear;
    // yearRange;
    // bDate;
    // constructor(private userService: UserService, private commonService: CommonService, private formBuilder: FormBuilder,
    //     private confirmationService: ConfirmationService, private messageService: MessageService,
    //     private router: Router, private activeroute: ActivatedRoute) { }

    // ngOnInit(): void {
    //     this.yearRange = this.minYear + ":" + maxYearFunction();
    //     this.id = this.activeroute.snapshot.params.id;
    //     this.statuses = [
    //         { label: 'Active', value: true },
    //         { label: 'In-Active', value: false }
    //     ];
    //     this.genders = [
    //         { name: 'Male', code: 'Male' },
    //         { name: 'Female', code: 'Female' },
    //         { name: 'Other', code: 'Other' },
    //     ];
    //     this.getUserDetails(this.id);

    //     this.userForm = this.formBuilder.group({
    //         // firstName: ['', [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z]*$')]],
    //         // lastName: ['', [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z]*$')]],
    //         firstName: ['', {
    //             validators: [Validators.required, Validators.pattern('[A-Za-z][A-Za-z]*$')], updateOn: 'blur'
    //           }],
    //           lastName: ['', {
    //             validators: [Validators.required, Validators.pattern('[A-Za-z][A-Za-z]*$')], updateOn: 'blur'
    //           }],
    //         email: ['', [Validators.required, Validators.email, CustomValidators.email]],
    //         // password: ['', [Validators.required, Validators.minLength(6)]],
    //         // confirmPassword: ['', Validators.required],
    //         mobileNumber: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
    //         address: [''],
    //         country: ['', Validators.required],
    //         state: [''],
    //         city: [''],
    //         zipcode: [''],
    //         status: [''],
    //         gender: [''],
    //         dob: [],
    //         //weddingDate: [],
    //     }, {
    //         //validator: MustMatch('password', 'confirmPassword')
    //     });
    // }

    // getUserDetails(id) {
    //     this.userService.getUserDetails(id).subscribe(
    //         data => {
    //             this.item = data;
    //             if (this.item) {
    //                 this.countrycode = this.item['country_id'];
    //                 this.getCountry();
    //                 if(this.item['state_id'] != undefined && this.item['city_id'] != undefined) {
    //                     this.getStates("false", this.item['country_id']);
    //                     this.statecode = this.item['state_id'];
    //                     this.getCities("false", this.item['state_id']);
    //                     this.citycode = this.item['city_id'];
    //                 }

    //                 this.userForm.patchValue({
    //                     firstName: this.item['firstName'],
    //                     lastName: this.item['lastName'],
    //                     email: this.item['email'],
    //                     mobileNumber: this.item['mobileNumber'],
    //                     country: this.item['country'],
    //                     state: this.item['state'],
    //                     city: this.item['city'],
    //                     zipcode: this.item['zipcode'],
    //                     address: this.item['address'],
    //                 });

    //                 if (this.item['dob'] != '' && this.item['dob'] != undefined) {
    //                     this.userForm.get('dob').setValue(moment(this.item['dob']).format('DD/MM/YYYY'));
    //                     this.dobdt = this.item['dob'];
    //                 }
    //                 // if(this.item['weddingDate'] != '' && this.item['weddingDate'] != undefined) {
    //                 //     this.userForm.get('weddingDate').setValue(moment(this.item['weddingDate']).format('DD/MM/YYYY'));
    //                 //     this.weddingDt = this.item['weddingDate'];
    //                 // }

    //                 var statusobj;
    //                 if (this.item['status'] == true) {
    //                     statusobj = { label: 'Active', value: true };
    //                 } else {
    //                     statusobj = { label: 'In-Active', value: false };
    //                 }

    //                 this.userForm.get('status').setValue(statusobj);
    //                 this.userForm.get('gender').setValue({ name: this.item['gender'], code: this.item['gender'] });
    //                 if (this.item['profilepic'] != undefined) {
    //                     this.imageProfile = this.item['profilepic'];
    //                     this.showProfile = true;
    //                 } else {
    //                     this.showProfile = false;
    //                 }
    //             }
    //             this.userForm.get('email').disable()
    //         },
    //         err => {
    //             this.errorMessage = err.error.message;
    //         }
    //     );
    // }

    // get f() {
    //     return this.userForm.controls;
    // }

    // picUploader(event) {
    //     for (let file of event.files) {
    //         this.uploadedFiles.push(file);
    //         var reader = new FileReader();
    //         reader.readAsDataURL(this.uploadedFiles[0]);
    //         reader.onload = () => { // called once readAsDataURL is completed
    //             this.profilepic = reader.result;
    //         }
    //     }
    // }

    // getCountry() {
    //     this.commonService.getCountryList().subscribe(
    //         data => {
    //             this.countrylist = data.data.items;
    //             this.countrylist.forEach(element => {
    //                 if (element.id == this.countrycode) {
    //                     this.userForm.get('country').setValue({ name: element.name, id: element.id });
    //                 }
    //             });
    //         },
    //         err => {
    //             this.errorMessage = err.error.message;
    //         }
    //     );
    // }

    // getStates(fromForm, event) {
    //     this.citylist = [];
    //     this.statecode = "";
    //     this.statename = "";
    //     this.citycode = "";
    //     this.cityname = "";

    //     if (fromForm == "true") {
    //         this.userForm.get('zipcode').reset();
    //         this.countrycode = event.value.id;
    //         this.countryname = event.value.name;
    //     } else {
    //         this.countrycode = event;
    //     }

    //     this.commonService.getStateList(this.countrycode).subscribe(
    //         data => {
    //             this.statelist = data.data.items;
    //             this.statelist.forEach(element => {
    //                 if (element.id == this.statecode) {
    //                     this.userForm.get('state').setValue({ name: element.name, id: element.id });
    //                 }
    //             });
    //         },
    //         err => {
    //             this.errorMessage = err.error.message;
    //         }
    //     );
    // }

    // getCities(fromForm, event) {
    //     this.citycode = "";
    //     this.cityname = "";
    //     if (fromForm == "true") {
    //         this.userForm.get('zipcode').reset();
    //         this.statecode = event.value.id;
    //         this.statename = event.value.name;
    //     } else {
    //         this.statecode = event;
    //     }


    //     this.commonService.getCityList(this.statecode).subscribe(
    //         data => {
    //             this.citylist = data.data.items;
    //             this.citylist.forEach(element => {
    //                 if (element.id == this.citycode) {
    //                     this.userForm.get('city').setValue({ name: element.name, id: element.id });
    //                 }
    //             });
    //         },
    //         err => {
    //             this.errorMessage = err.error.message;
    //         }
    //     );
    // }

    // onCitySelect(event) {
    //     this.cityname = event.value.name;
    //     this.citycode = event.value.id;
    //     this.userForm.get('zipcode').reset();
    // }

    // onStatusSelect(event) {
    //     if (event) {
    //         this.userstatus = event.value;
    //     }
    // }

    // onGenderSelect(event) {
    //     if (event) {
    //         this.usergender = event.name;
    //     }
    // }

    // setDOB($event) {
    //     this.dobdt = $event; //moment($event).format("MM/DD/YYYY");
    // }
    // setWeddingDate($event) {
    //     this.weddingDt = $event; //moment($event).format("MM/DD/YYYY");
    // }

    // onSubmit() {
    //     this.submitted = true;
    //     if (this.userForm.invalid) {
    //         return;
    //     }
    //     var userData = this.userForm.value;
    //     //userData['profilepic'] =this.profilepic;
    //     userData['status'] = this.userstatus;
    //     userData['gender'] = this.usergender;

    //     if (this.dobdt != undefined) {
    //         userData['dob'] = moment(this.dobdt).toDate();
    //     }
    //     // if (this.weddingDt != undefined) {
    //     //     userData['weddingDate'] = moment(this.weddingDt).toDate();
    //     // }

    //     // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.userForm.value, null, 4));
    //     // return;
    //     //var userData = JSON.stringify(this.userForm.value, null, 4);
    //     userData = JSON.stringify(userData, null, 4);
    //     // return;
    //     this.userService.updateUser(this.id, userData).subscribe(
    //         data => {
    //             this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Data Updated Successfully!!', life: 6000 });
    //             setTimeout(() => {
    //                 this.router.navigate(['/manage/customer/user']);
    //             }, 2000);
    //         },
    //         err => {
    //             //this.errorMessage = err.error.message;
    //         }
    //     );
    // }

    // onReset() {
    //     this.submitted = false;
    //     this.userForm.reset();
    // }


    id;
    userForm: FormGroup;
    submitted = false;
    uploadedFiles: any[] = [];
    file: File;
    reader: FileReader;
    public profilepic;
    errorMessage = '';
    public item: any[] = [];
    countrylist: any = [];
    statelist: any = [];
    citylist: any = [];
    genders: any = [];
    public imageProfile;
    showProfile = false;
    statuses: any = [];
    approvedstatuses: any = [];
    userstatus: any;
    videostatus: any;
    usergender: any;
    selectedStatus: any;
    countryname;
    countrycode;
    statename;
    statecode;
    cityname;
    citycode;
    dob: Date;
    bDate;
    dobdt: Date;
    yearRange;
    public defaultDate: Date = new Date(environment.defaultDate);
    minYear = environment.minYear;
    timeZoneArray = [];
    timeZoneOffset;
    timeZone;
    cpassword: boolean;
    newPasswordCheck: boolean;
    newPasswordDisable: boolean;
    public loggedInUser;
    public isLoggedIn: boolean;
    public userId;
    public userDetails;

    public videoForm: FormGroup;
    public videoUploadedFiles: any[] = [];
    public userVideo;
    public showVideoError: boolean = false;
    public selectedPlayerVideo;
    public isVideoApproved: boolean = false;
    public contactVideoApproved: boolean = false;
    public videoSize = environment.imageSize;
    userMenuList: MenuItem[];
    rejectModal: boolean;
    user: any;
    rejectedReasonList: any[];
    selectedCategory: any;
    public userCategories = environment.userCategories;
    public userCategory;
    roleName: string;
    showRating: boolean;
    proplayerRating: any;
    userRoleId: any;
    roleService: any;
    categoryRoleId: any;
    userData: any;
    rolearray: any;
    selectedRoleid;
    @ViewChild('fileUpload') fileUpload!: FileUpload;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    cropDialog: boolean = false;
    selectedFile: File | null = null;
    imageSize = 1000000;
    croppedImageMaxSize = 1000000;
    croppedImageSize = 0;
    croppedImageError: string | null = null;
    scale = 1;
    transform: ImageTransform = {};
    constructor(private userService: UserService, private commonService: CommonService, private formBuilder: FormBuilder, private messageService: MessageService,
        private router: Router, private activeroute: ActivatedRoute, private tokenStorage: TokenStorageService) { }
    acceptOrReject: any[] = [
        { name: 'Yes', key: true },
        { name: 'No', key: false },
    ];

    ngOnInit(): void {
        this.userId = this.activeroute.snapshot.params.id;

        //   this.loggedInUser = this.tokenStorage.getUser();
        this.rolearray = this.tokenStorage.getRolelist();
        //   if (this.loggedInUser.userdata != undefined) {
        //       this.isLoggedIn = true;
        //       this.userId = this.loggedInUser.userdata.id;

        //   }
        //   if (this.isLoggedIn == false) {
        //       this.router.navigate(['/']);
        //   }
        const timeZones = moment.tz.names();
        for (const timezone of timeZones) {
            this.timeZoneArray.push({ name: timezone, code: moment().tz(timezone).format('Z') });
        }
        this.defaultDate.setDate(this.defaultDate.getDate() - 5);
        this.yearRange = this.minYear + ":" + maxYearFunction();
        this.id = this.activeroute.snapshot.params.id;
        this.id = this.userId;
        this.statuses = [
            { label: 'Active', value: true },
            { label: 'In-Active', value: false }
        ];
        this.approvedstatuses = [
            { label: 'Approved', value: true },
            { label: 'Not Approved', value: false }
        ];
        this.genders = [
            { name: 'Male', code: 'Male' },
            { name: 'Female', code: 'Female' },
            { name: 'Other', code: 'Other' },
        ];
        this.getCountry();
        this.userForm = this.formBuilder.group({
            //   firstName: ['', [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z]*$')] ],
            //   lastName: ['', [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z]*$')]],
            firstName: ['', {
                validators: [Validators.required, Validators.pattern('[A-Za-z][A-Za-z]*$')], updateOn: 'blur'
            }],
            lastName: ['', {
                validators: [Validators.required, Validators.pattern('[A-Za-z][A-Za-z]*$')], updateOn: 'blur'
            }],
            email: ['', [Validators.required, Validators.email, CustomValidators.email]],
            // password: ['', [Validators.required, Validators.minLength(6)]],
            // confirmPassword: ['', Validators.required],
            mobileNumber: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
            address: [''],
            country: ['', Validators.required],
            state: [''],
            city: [''],
            zipcode: ['', Validators.required],
            status: [''],
            gender: ['', Validators.required],
            dob: ['', Validators.required],
            currentPassword: [''],
            password: [''],
            confirmPassword: [''],
            videostatus: [''],
            // roleName: [''],
            isplayerVideoApproved: [false],
            isPlayerVideoRejected: [false],
            comment: [''],
            proplayerRating: [''],

        }, {
            //   validator: MustMatch('password', 'confirmPassword')
        });

        this.cpassword = false;
        this.newPasswordCheck = false;
        this.newPasswordDisable = true;
        this.userCategories.forEach(element => {
            this.userForm.addControl(element.slug, new FormControl());
        })

    }

    newPassword(event) {
        if (this.userForm.controls['password'].value != '' && this.userForm.controls['currentPassword'].value == '') {
            this.userForm.controls['currentPassword'].setValidators([Validators.required]);
            this.cpassword = true;
            this.newPasswordCheck = false;
        } else {
            this.cpassword = false;
        }
    }
    newPasswordValidation(event) {
        this.userForm.get('password').enable()
        this.userForm.get('confirmPassword').enable()
        if (this.userForm.controls['currentPassword'].value != '' && this.userForm.controls['password'].value == '') {
            this.userForm.controls['password'].setValidators([Validators.pattern("^(?=[^A-Z\n]*[A-Z])(?=[^a-z\n]*[a-z])(?=[^0-9\n]*[0-9])(?=[^#?!@$%^&*\n-]*[#?!@$%^&*-]).{6,}$")]);
            this.newPasswordCheck = true;
            this.cpassword = false;
        } else {
            this.newPasswordCheck = false;
        }
    }

    getUserDetails(id) {
        this.userService.getUserDetails(id).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.item = data;
                if (this.item) {
                    if (this.item['isParent'] === false && this.item['parentId']) {
                        this.item['mobileNumber'] = this.item['parentMobile'] || this.item['mobileNumber'];
                        this.item['email'] = this.item['parentEmail'] || this.item['email'];
                        this.item['countryname'] = this.item['parentCountry'] || this.item['countryname'];
                        this.item['countrycode'] = this.item['parentCountryCode'] || this.item['countrycode'];
                        this.item['statename'] = this.item['parentState'] || this.item['statename'];
                        this.item['statecode'] = this.item['parentStateCode'] || this.item['statecode'];
                        this.item['cityname'] = this.item['parentCity'] || this.item['cityname'];
                        this.item['citycode'] = this.item['parentCityCode'] || this.item['citycode'];
                        this.item['zipcode'] = this.item['parentPincode'] || this.item['zipcode'];
                        this.item['address'] = this.item['parentAddress'] || this.item['address'];
                    }
                    if (this.item['gender']) {
                        this.item['gender'] = this.item['gender'].charAt(0).toUpperCase() + this.item['gender'].slice(1).toLowerCase();
                    }

                    this.getStates("false", this.item['countrycode']);
                    this.userForm.get('country').setValue({ name: this.item['countryname'], code: this.item['countrycode'] });
                    if (this.item['statecode']) {
                        this.getCities("false", this.item['statecode']);
                        this.userForm.get('state').setValue({ name: this.item['statename'], code: this.item['statecode'] });
                    }
                    if (this.item['citycode']) {
                        this.userForm.get('city').setValue({ name: this.item['cityname'], code: this.item['citycode'] });
                    }
                    var bDate = moment(this.item['dob'], 'DD-MM-YYYY');

                    this.bDate = bDate.format('DD-MM-YYYY');
                    this.userForm.patchValue({
                        firstName: this.item['firstName'],
                        lastName: this.item['lastName'],
                        email: this.item['email'],
                        mobileNumber: this.item['mobileNumber'],
                        // country: this.item['country'],
                        // state: this.item['state'],   
                        // city: this.item['city'],
                        zipcode: this.item['zipcode'],
                        address: this.item['address'],
                        dob: this.item['dob'],
                        proplayerRating: this.item['proplayerRating']
                    });

                    if (this.item['rolename']) {

                        this.userCategories.forEach(element => {
                            let obj = { name: element.name, value: element.value, status: false, slug: element.slug };
                            if (element.slug == this.item['rolename']) {
                                const index = this.findIndexBySlug(element.value, this.userCategories);
                                obj = { name: element.name, value: element.value, slug: element.slug, status: true };
                                this.userCategories[index] = obj;
                                this.userForm.get(element.slug).setValue(obj);
                            }
                        })
                    }

                    if (this.item['rolename'] === "proplayer") {
                        this.showRating = true;
                        this.userForm.get('proplayerRating').setValidators(Validators.required);
                    }


                    this.countrycode = this.item['countrycode'];
                    this.countryname = this.item['countryname'];
                    this.statecode = this.item['statecode'];
                    this.statename = this.item['statename'];
                    this.citycode = this.item['citycode'];
                    this.cityname = this.item['cityname'];
                    this.selectedPlayerVideo = this.item['playervideoClip'];
                    this.rejectedReasonList = this.item["rejectedReasons"]
                    this.selectedRoleid = this.item['role'];
                    // var statusobj;
                    // if (this.item['status'] == true) {
                    //     statusobj = { label: 'Active', value: true };
                    // } else {
                    //     statusobj = { label: 'In-Active', value: false };
                    // }
                    this.userForm.get('status').setValue(this.item['status']);
                    this.userForm.get('gender').setValue({ name: this.item['gender'], code: this.item['gender'] });
                    var videostatusobj;
                    var videoApproveStatus;
                    var videoRejectStatus;



                    if (this.item['isplayerVideoApproved'] == true) {
                        // videostatusobj = { label: 'Approved', value: true };
                        videoApproveStatus = true;
                        videoRejectStatus = false;

                    } else if (this.item['isPlayerVideoRejected'] == true) {
                        videoApproveStatus = false;
                        videoRejectStatus = true;
                        // videostatusobj = { label: 'Not Approved', value: false };
                    }

                    else if (this.item['isPlayerVideoRejected'] == false && this.item['isplayerVideoApproved'] == false) {
                        videoApproveStatus = false;
                        videoRejectStatus = false;

                    }
                    this.userForm.get('videostatus').setValue(videostatusobj);
                    this.userForm.get('isplayerVideoApproved').setValue(videoApproveStatus);
                    // this.userForm.get('isPlayerVideoRejected').setValue(videoRejectStatus);
                    if (this.item['playervideoClip'] == "") {
                        this.userForm.get('isplayerVideoApproved').disable()
                        this.userForm.get('isPlayerVideoRejected').disable()
                    }
                    if (this.item['profilepic'] != undefined) {
                        this.imageProfile = this.item['profilepic'];
                        this.showProfile = true;
                    } else {
                        this.showProfile = false;
                    }


                }

                this.userForm.get('password').disable()
                this.userForm.get('confirmPassword').disable();
                this.userMenuList = [
                    // {
                    // label: 'Edit Player',
                    // icon: 'pi pi-pencil',
                    // // routerLink: "/manage/customer/user/" + this.userRoleId,
                    // command: () => {
                    // this.editUser(element.id);
                    // }
                    // },
                    {
                        label: 'Wallet History',
                        icon: 'pi pi-wallet',
                        command: () => {
                            this.userWallet(this.id);
                        }
                    },
                    {
                        label: 'Player Schedule',
                        icon: 'pi pi-clock',
                        command: () => {
                            this.userscheduleList(this.id);
                        }

                    },
                    {
                        label: 'Tournaments Registration',
                        icon: 'pi pi-flag',
                        command: () => {
                            this.userTournamentLog(this.id);
                        }
                    },
                    {
                        label: "Player's Achievment",
                        icon: 'pi pi-flag',
                        command: () => {
                            this.userTournamentCertificate(this.id);
                        }
                    },
                    {
                        label: 'Address Log',
                        icon: 'pi pi-home',
                        command: () => {
                            this.userAddressLog(this.id);
                        }
                    },
                    // {
                    // label: 'Ranking List',
                    // icon: 'pi pi-chart-line',
                    // command: () => {
                    // this.rankinggList(this.id);
                    // }
                    // },
                    // {
                    //     label: 'Opponent List',
                    //     icon: 'pi pi-user',
                    //     command: () => {
                    //         this.opponentList(this.id);
                    //     }
                    // },

                    {
                        label: 'User kyc',
                        icon: 'pi pi-verified',
                        command: () => {
                            this.userKyc(this.id);
                        }
                    },
                    {
                        label: 'Matches Information',
                        icon: 'bx bx-trophy',
                        command: () => {
                            this.matchesIfo(this.id);
                        }
                    },
                    // {
                    //     label: 'Ranking History',
                    //     icon: 'pi pi-chart-bar',
                    //     command: () => {
                    //         this.rankHistory(this.id);
                    //     }
                    // },
                    // {
                    //     label: 'Skill History',
                    //     icon: 'pi pi-list',
                    //     command: () => {
                    //         this.skillHistory(this.id);
                    //     }
                    // },
                    // {
                    // label: 'Delete User',
                    // icon: 'pi pi-trash',
                    // command: () => {
                    // this.deleteUser(this);
                    // }
                    // },



                ];
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    get f() {
        return this.userForm.controls;
    }

    onFileSelect(event: any) {
        const file = event.files[0];
        if (!file) return;
        if (file.size > this.imageSize) {
            this.rejectOversizedImage();
            return;
        }
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = file;
        const fileEvent: any = {
            target: {
                files: [file]
            }
        };
        this.imageChangedEvent = fileEvent;
        this.cropDialog = true;
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
        this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
        this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
            ? 'Cropped image size must be less than 1 MB.'
            : null;
    }

    getBase64SizeBytes(base64: string): number {
        if (!base64) return 0;
        return Math.round(
            (base64.length * (3 / 4)) -
            (base64.split(',')[0].length + 1)
        );
    }

    applyCrop() {
        if (this.croppedImageError) return;
        const file = this.base64ToFile(
            this.croppedImage,
            this.selectedFile?.name || 'image.png'
        );
        if (file.size > this.croppedImageMaxSize) {
            this.croppedImageError = 'Cropped image size must be less than 1 MB.';
            return;
        }
        this.fileUpload.clear();
        const event = {
            files: [file]
        };
        this.picUploader(event);
        this.fileUpload.files = [file];

        this.cropDialog = false;
    }

    onCropCancel() {
        this.cropDialog = false;
        this.imageChangedEvent = null;
        this.croppedImage = null;
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = null;
        if (this.fileUpload) {
            this.fileUpload.clear();
        }
        this.uploadedFiles = [];
        this.profilepic = null;
    }

    rejectOversizedImage() {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image smaller than 1 MB', life: 6000 });
        this.onCropCancel();
    }

    base64ToFile(data: string, filename: string): File {
        const arr = data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    picUploader(event) {
        //console.log('',event);    
        for (let file of event.files) {
            this.uploadedFiles.push(file);
            var reader = new FileReader();
            reader.readAsDataURL(this.uploadedFiles[0]);
            reader.onload = () => { // called once readAsDataURL is completed            
                this.profilepic = reader.result;
            }
        }
    }

    onCategorySelect(userCategory, event) {

        this.userCategory = '';
        if (event.isTrusted) {
            this.userCategory = userCategory.value;

            this.userCategories.forEach(element => {
                let obj = { name: element.name, value: element.value, status: element.status, slug: element.slug };
                if (this.userCategory == element.value) {
                    const index = this.findIndexByValue(element.value, this.userCategories);
                    obj = { name: element.name, value: element.value, status: true, slug: element.slug };
                    this.userCategories[index] = obj;
                    this.userForm.get(element.slug).setValue(obj);
                    const roleindex = this.findIndexByRole(element.slug, this.rolearray);
                    this.selectedRoleid = this.rolearray[roleindex]['roleid'];
                } else {
                    const index = this.findIndexByValue(element.value, this.userCategories);
                    obj = { name: element.name, value: element.value, status: false, slug: element.slug };
                    this.userCategories[index] = obj;
                }
                this.showRating = false;
                if (this.userCategory === "proplayer") {
                    this.showRating = true;
                    this.userForm.get('proplayerRating').setValidators(Validators.required);
                } else {
                    this.userForm.get('proplayerRating').setValue(0);
                }

            });
        }
    }
    findIndexByValue(value, arrayName) {
        let index = -1;
        for (let i = 0; i < arrayName.length; i++) {
            if (arrayName[i].value === value) {
                index = i;
                break;
            }
        }
        return index;
    }

    findIndexByRole(value, arrayName) {
        let index = -1;
        for (let i = 0; i < arrayName.length; i++) {
            if (arrayName[i].rolename === value) {
                index = i;
                break;
            }
        }
        return index;
    }




    findIndexBySlug(slug, arrayName) {
        let index = -1;
        for (let i = 0; i < arrayName.length; i++) {
            if (arrayName[i].slug === slug) {
                index = i;
                break;
            }
        }
        return index;
    }
    getCountry() {
        this.commonService.getCountryList().pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                if (data.data.items.length > 0) {
                    data.data.items.forEach(element => {
                        let countryObj = {
                            name: element.name,
                            code: element.code,
                        }
                        this.countrylist.push(countryObj);
                    });
                }
                this.getUserDetails(this.id);
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    getStates(fromForm, event) {
        this.citylist = [];
        this.statecode = "";
        this.statename = "";
        this.citycode = "";
        this.cityname = "";

        if (fromForm == "true") {
            this.userForm.get('zipcode').reset();
            this.countrycode = event.value.code;
            this.countryname = event.value.name;
        } else {
            this.countrycode = event;
        }

        this.commonService.getStateList(this.countrycode).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.statelist = data.data.items;
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    getCities(fromForm, event) {
        this.citycode = "";
        this.cityname = "";
        if (fromForm == "true") {
            this.userForm.get('zipcode').reset();
            this.statecode = event.value.code;
            this.statename = event.value.name;
        } else {
            this.statecode = event;
        }


        this.commonService.getCityList(this.statecode).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.citylist = data.data.items;
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    onCitySelect(event) {
        this.cityname = event.value.name;
        this.citycode = event.value.code;
        this.userForm.get('zipcode').reset();
    }

    onStatusSelect(event) {
        if (event) {
            this.userstatus = event.value;
        }
    }

    onClickCategory() {

    }
    onGenderSelect(event) {
        if (event) {
            this.usergender = event.name;
        }
    }

    onTimezoneSelect(event) {
        this.timeZone = event.name;
        this.timeZoneOffset = event.code;
    }

    setDOB($event) {
        this.dobdt = $event; //moment($event).format("MM/DD/YYYY");
    }
    removeFile(event) {
        this.uploadedFiles = [];
        this.profilepic = "{{imageProfile}}";
    }
    onSubmit() {
        this.userId = this.activeroute.snapshot.params.id;
        this.submitted = true;
        if (this.userForm.invalid) {
            return;
        }
        // return;
        // var userData = this.userForm.value;
        //userData['profilepic'] =this.profilepic;
        // userData['status'] = this.userstatus;
        // userData['gender'] = this.usergender;
        var userData = this.userForm.value;
        if (this.userForm.value.comment != "") {
            userData.rejectedReasons = {
                comment: userData.comment,
                dateOfRejection: new Date()
            }
        };
        delete userData.comment
        userData['profilepic'] = this.profilepic;
        // userData['status'] = this.userstatus;
        // userData['isplayerVideoApproved'] = this.videostatus;
        userData['roleid'] = this.selectedRoleid;
        userData['countrycode'] = this.countrycode;
        userData['countryname'] = this.countryname;
        userData['statecode'] = this.statecode;
        userData['statename'] = this.statename;
        userData['citycode'] = this.citycode;
        userData['cityname'] = this.cityname;
        userData['gender'] = this.usergender;
        userData['rolename'] = this.userCategory;

        userData['isProfileComplete'] = true;
        if (this.dobdt != undefined) {
            userData['dob'] = moment(this.dobdt).toDate();
        }
        if (this.userForm.value.dob instanceof Date) {
            userData['dob'] = moment(this.userForm.value.dob, "DD-MM-YYYY").format("YYYY-MM-DD");
        } else {
            var dt = moment(this.userForm.value.dob, "DD-MM-YYYY").format("YYYY-MM-DD");
            userData['dob'] = dt;
        }
        userData['playervideo'] = this.userVideo;


        // if (this.weddingDt != undefined) {
        //     userData['weddingDate'] = moment(this.weddingDt).toDate();
        // }

        // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.userForm.value, null, 4));
        // return;
        //var userData = JSON.stringify(this.userForm.value, null, 4);
        userData = JSON.stringify(userData, null, 4);
        // return;
        this.userService.updateUser(this.id, userData).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Data Updated Successfully!!', life: 6000 });
                if (this.userForm.value.comment !== "" && this.userForm.value.comment !== undefined) {
                    setTimeout(() => {
                        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                        this.router.onSameUrlNavigation = 'reload';
                        this.router.navigate([this.router.url]);
                    }, 2000);
                } else {

                    setTimeout(() => {
                        this.router.navigate(['/manage/customer/user']);
                    }, 2000);
                }
            },
            err => {
                this.errorMessage = err.error.message;
                this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: this.errorMessage, life: 6000 });
            }
        );
    }

    //   onSubmit() {
    //     this.userId = this.activeroute.snapshot.params.id;
    //       this.submitted = true;
    //       if (this.userForm.invalid) {
    //           return;
    //       }
    //   var userData = this.userForm.value;
    //   userData['profilepic'] = this.profilepic;
    //   userData['status'] = this.userstatus;
    //   userData['countrycode'] = this.countrycode;
    //   userData['countryname'] = this.countryname;
    //   userData['statecode'] = this.statecode;
    //   userData['statename'] = this.statename;
    //   userData['citycode'] = this.citycode;
    //   userData['cityname'] = this.cityname;
    //   userData['gender'] = this.usergender;
    //       console.log('userData',userData,'ID',this.id);
    //   if (this.userForm.value.dob instanceof Date) {
    //       userData['dob'] = moment(this.userForm.value.dob, "DD-MM-YYYY").format("YYYY-MM-DD");
    //   } else {
    //       var dt = moment(this.userForm.value.dob, "DD-MM-YYYY").format("YYYY-MM-DD");
    //       userData['dob'] = dt;
    //   }
    //       userData = JSON.stringify(userData, null, 4);
    //       this.userService.updateUser(this.userId, userData).subscribe(
    //           data => {                
    //               this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'USER Updated Successfully!!', life: 6000 });
    //               setTimeout(() => {
    //                   this.router.navigate(['/manage/customer/user']);
    //               }, 2000);
    //           },
    //           err => {
    //               //this.errorMessage = err.error.message;
    //           }
    //       );
    //   }

    onReset() {
        this.submitted = false;
        this.userForm.reset();
    }
    // onTabClick(mode) {
    //     if (mode == "logout") {
    //         this.signOut();
    //     }

    // }
    // signOut() {
    //     window.sessionStorage.clear();
    //     this.tokenStorage.isLoggedOut();
    //     // this.router.navigateByUrl("/");
    //     // this.isLoggedIn = false;
    //     window.location.reload();
    //     return false;
    // }

    backLink() {
        this.router.navigate(['/manage/customer/user']);
    }
    videoUploader(event) {
        let index = 0;
        for (let file of event.files) {
            this.videoUploadedFiles.push(file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                // called once readAsDataURL is completed
                if (reader.result != null) {
                    //this.sponsorImage.push({ 'file': reader.result });
                    this.userVideo = reader.result;
                    index++;
                }
            }
        }
    }
    removeVideoFile(event) {
        this.videoUploadedFiles = [];
        //this.profilepic = "{{imageProfile}}";
    }
    onVideoStatusSelect(event) {
        if (event) {
            this.videostatus = event.value;
        }
    }
    addNewUser() {
        this.router.navigate(['/manage/user/add']);
    }

    viewUser(id) {
        this.router.navigate(['/manage/customer/user/view/' + id]);
    }
    userWallet(id) {
        this.router.navigate(['/manage/customer/user/wallet/' + id]);
    }

    userTournamentLog(id) {
        this.router.navigate(['/manage/customer/user/player-tournament/' + id]);
    }
    userTournamentCertificate(id) {
        this.router.navigate(['/manage/customer/user/player-certificate/' + id]);
    }
    userAddressLog(id) {
        this.router.navigate(['/manage/customer/user/addresslog/' + id]);
    }

    editUser(id) {
        this.router.navigate(['/manage/customer/user/' + id]);
    }

    userscheduleList(id) {
        this.router.navigate(['/manage/customer/user/userscheduleList/' + id]);
    }
    rankinggList(id) {
        this.router.navigate(['/manage/user/ranking-list/' + id]);
    }
    opponentList(id) {
        this.router.navigate(['/manage/user/skilled-opponent/' + id]);
    }
    userKyc(id) {
        this.router.navigate(['/manage/customer/user/kyc/' + id]);
    }
    matchesIfo(id) {
        this.router.navigate(['/manage/user/matches-info/' + id]);
    }
    rankHistory(id) {
        this.router.navigate(['/manage/user/ranking-history/' + id]);
    }
    skillHistory(id) {
        this.router.navigate(['/manage/user/skill-history/' + id]);
    }

    showRejectmodal(show) {
        if (show == "Yes") {
            if (this.selectedPlayerVideo != "") {
                this.userForm.controls.comment.setValidators([Validators.required]);
                this.userForm.controls.comment.updateValueAndValidity();
                this.userForm.controls.isplayerVideoApproved.setValue(false);
                this.rejectModal = true;

            }
        }
        // this.user = data
    }
    onRejectModalClose() {
        if (this.item["isPlayerVideoRejected"] == false) {
            this.userForm.controls.isPlayerVideoRejected.setValue(false);
        }
    }
    onApproveclick(status) {
        if (status == "Yes") {
            this.userForm.controls.isPlayerVideoRejected.setValue(false);
        }
    }

    get cropDialogTitle(): string {
        return 'Crop & Adjust Player Photo';
    }

    get cropDialogSubtitle(): string {
        return 'Position and scale image to fit mandatory 512 x 512 dimensions';
    }

    get cropPreviewLabel(): string {
        return '512 x 512 px';
    }
    zoomIn() {
        this.scale += 0.1;

        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    zoomOut() {
        if (this.scale > 0.2) {
            this.scale -= 0.1;

            this.transform = {
                ...this.transform,
                scale: this.scale
            };
        }
    }

    resetZoom() {
        this.scale = 1;

        this.transform = {
            ...this.transform,
            scale: 1
        };
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
